import React, { useState } from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@column/ui';

import { TableFilterTrigger } from './TableFilterTrigger';

export interface TableSelectFilterOption {
  label: string;
  value: string;
}

interface TableSelectFilterProps {
  label: string;
  options: TableSelectFilterOption[];
  value?: string;
  onChange: (value: string | undefined) => void;
}

const ALL_VALUE = '__all__';

export const TableSelectFilter: React.FC<TableSelectFilterProps> = ({ label, options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find((option) => option.value === value);

  return (
    <DropdownMenu modal={false} open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <TableFilterTrigger isActive={Boolean(selected)} isOpen={open}>
          {selected?.label ?? label}
        </TableFilterTrigger>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={8}>
        <DropdownMenuRadioGroup
          value={value ?? ALL_VALUE}
          onValueChange={(next) => onChange(next === ALL_VALUE ? undefined : next)}
        >
          <DropdownMenuRadioItem value={ALL_VALUE}>All</DropdownMenuRadioItem>
          <DropdownMenuSeparator />
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
